import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class WindowService implements Partial<Window> {
    [key: string]: any;

    public open(url: string, ...args: any[]): any {
        return window.open(url, ...args);
    }

    public getLocation() {
        return window.location.href;
    }
}
